<template>
	<div id="ReviseEvectionreport">
		<div class="title">
			<p class='Name'>修改报告</p>
		</div>
		<div class='RevisereportForm' v-loading='SubFormLoading' element-loading-text="数据正在保存，请不要关闭页面">
			<el-form :model="RevisereportForm" :rules="rules" ref="RevisereportForm" label-width="80px" class="demo-ruleForm" label-position="left" v-loading='FormLoading'>
				<el-form-item label="出差日期">
					<el-date-picker v-model="RevisereportForm.开始时间" type="date" placeholder="开始日期" size='small' :picker-options="pickerOptions" value-format='yyyy-MM-dd'></el-date-picker>
				</el-form-item>
			</el-form>
			<el-form :model="ReviseJourneyForm" :rules="rules" ref="ReviseJourneyForm" label-width="120px" class="demo-ruleForm" label-position="left" v-loading='FormLoading'>
				<div v-for="(domain, index) in ReviseJourneyForm.domains" :key="domain.key">
					<p>{{'行程 ' + (index +1)}}</p>
					<el-form-item 
						:label="'拜访方式'"
						:prop="'domains.' + index + '.拜访方式'"
						:rules="{
							required: true, message: ' ', trigger: 'blur'
						}"
					>
						<el-radio-group v-model="domain.拜访方式">
							<el-radio label="当面沟通"></el-radio>
							<el-radio label="线上沟通(微信/电话)"></el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item 
						:label="'客户类型'"
						:prop="'domains.' + index + '.拜访类型'"
						:rules="{
							required: true, message: ' ', trigger: 'blur'
						}"
					>
						<el-radio-group v-model="domain.拜访类型" @change='ChangeObject(index,domain.拜访类型)'>
							<el-radio label="经销商">经销商</el-radio>
							<el-radio label="物业">物业</el-radio>
						</el-radio-group>
					</el-form-item>
					
					<el-form-item 
						:label="'客户名称'"
						:prop="'domains.' + index + '.拜访ID'"
						:key="domain.key"
						:rules="{
							required: true, message: ' ', trigger: 'blur'
						}">
							<el-select v-model="domain.拜访ID" filterable remote reserve-keyword placeholder="请输入拜访人名称"  @change='remoteLinkman(domain.拜访ID,index,domain.拜访类型)' :remote-method="(val)=>remoteMethod(val,index,domain.拜访类型,domain)" :loading="loading">
								<el-option v-for="item in domain.options" :key="item.ID" :label="item.企业名称 + '-' + item.市" :value="item.ID"> </el-option>
							</el-select>
							<el-button size='small' type='primary' @click='AddCompany(index,domain.拜访类型)' style="margin-left:10px;">添加</el-button>
						</el-form-item>
						<el-form-item 
							:label="'联系人'"
							:prop="'domains.' + index + '.联系人ID'"
							:rules="{
								required: true, message: ' ', trigger: 'blur'
							}">
							<el-select v-model="domain.联系人ID" filterable placeholder="请输入拜访人名称">
								<el-option v-for="item in domain.Linkoptions" :key="item.ID" :label="item.联系人 + '-' + item.职务" :value="item.ID"> </el-option>
							</el-select>
						<el-button size='small' type='primary' @click='AddLinkMan(domain.拜访ID,index,domain.拜访类型)' style="margin-left:10px;">添加</el-button>
					</el-form-item>
						<el-form-item 
						:label="'跟进主题'"
						:prop="'domains.' + index + '.主题'"
						:rules="{
						required: true, message: ' ',trigger: 'change'
						}">
						<el-select v-model="domain.主题" placeholder="请选择主题" multiple>
							<el-option v-for='(item,index) in domain.theme' :value='item.主题' :label='item.主题' :key='index'></el-option>
						</el-select>
					</el-form-item>
					<el-form-item 
						:label="'跟进内容'"
						:prop="'domains.' + index + '.跟进内容'"
						:rules="{
							required: true, message: ' ', trigger: 'blur'
						}"
					>
						<el-input type="textarea" v-model="domain.跟进内容" :autosize="{ minRows:9 , maxRows: 30}"></el-input>
					</el-form-item>
					<div v-if="domain.拜访类型 =='经销商'">
						<el-form-item 
							:label="'协助需求'"
							:prop="'domains.' + index + '.协助需求'"
							:rules="{
								required: true, message: ' ', trigger: 'blur'
							}"
						>
							<el-input type="textarea" v-model="domain.协助需求" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
						</el-form-item>
						<el-form-item 
							:label="'后续对策'"
							:prop="'domains.' + index + '.后续对策'"
							:rules="{
								required: true, message: ' ', trigger: 'blur'
							}"
						>
							<el-input type="textarea" v-model="domain.后续对策" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
						</el-form-item>
					</div>
					<el-form-item
						:label="'物业意见'"
						:prop="'domains.' + index + '.物业意见'"
					>
						<el-input v-model="domain.物业意见" type="textarea" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
					</el-form-item>
					<div v-if="domain.拜访类型 =='经销商'"> 
						<el-form-item 
							:label="'意向度'"
							:prop="'domains.' + index + '.意向度'"
							:rules="{
								required: true, message: ' ', trigger: 'change'
							}"
						>
							<el-select v-model="domain.意向度">
								<el-option label="高" value="高"></el-option>
								<el-option label="中" value="中"></el-option>
								<el-option label="低" value="低"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<el-form-item 
						:label="'拜访时长(分钟)'"
						:prop="'domains.' + index + '.跟进时长'"
						:rules="[
							{required: true, message: ' ', trigger: 'blur'},
							{ type: 'number', message: '请填写跟进时长'}
						]"
						onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
					>
						<el-input v-model.number="domain.跟进时长" placeholder='请输入拜访时长'></el-input>
					</el-form-item>
					<!-- 经销商必填项-->
					<div v-if="domain.拜访类型 =='经销商'"> 
						<el-form-item 
							:label="'意向商场'"
							:prop="'domains.' + index + '.意向商场'"
							:rules="{
								required: true, message: ' ', trigger: 'blur'
							}"
						>
							<el-input v-model="domain.意向商场"></el-input>
						</el-form-item>
						<el-form-item 
							:label="'意向位置'"
							:prop="'domains.' + index + '.意向位置'"
						>
							<el-input v-model="domain.意向位置"></el-input>
						</el-form-item>
						<el-form-item 
							:label="'投资预算'"
							:prop="'domains.' + index + '.投资预算'"
							onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
						>
							<el-input v-model.number="domain.投资预算" placeholder='请输入预算(元/平方)'></el-input>
						</el-form-item>
						<el-form-item 
							:label="'预算面积'"
							:prop="'domains.' + index + '.预算面积'"
							onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
						>
							<el-input v-model.number="domain.预算面积"></el-input>
						</el-form-item>
						<el-form-item 
							:label="'预计签约时间'"
							:prop="'domains.' + index + '.预计签约时间'"
						>
							<el-date-picker v-model="domain.预计签约时间" type="date" placeholder="预计预计签约时间" size='small' :picker-options="pickerDateTime" value-format='yyyy-MM-dd'></el-date-picker>
						</el-form-item>
						
					</div>
					
					<el-form-item 
						:label="'预计下次跟进'"
						:prop="'domains.' + index + '.预计下次跟进时间'"
					>
						<el-date-picker v-model="domain.预计下次跟进时间" type="date" placeholder="预计下次跟进日期" size='small' :picker-options="pickerDateTime" value-format='yyyy-MM-dd'></el-date-picker>
					</el-form-item>

					<el-form-item>
						<el-upload
							action="https://jsonplaceholder.typicode.com/posts/"
							list-type="picture-card"
							:on-preview="handlePictureCardPreview"
							:on-remove="(file, fileList)=>handleRemove(file, fileList,domain.ID,index)"
							:on-change="(file, fileList)=>imgBroadcastChange(file, fileList,index)"
							:auto-upload="false"
							:file-list="domain.图片">
							<i class="el-icon-plus"></i>
						</el-upload>
						<el-dialog :visible.sync="dialogVisible">
							<img width="100%" :src="dialogImageUrl" alt="">
						</el-dialog>
					</el-form-item>
					<el-popconfirm
						confirm-button-text='确认'
						cancel-button-text='取消'
						icon="el-icon-info"
						icon-color="red"
						title="是否确定删除此行程单吗？"
						@confirm="removeDomain(domain)"
					>
						<el-button size='mini' type='danger' slot="reference"  :style="{float:'right'}">删除行程</el-button>
					</el-popconfirm>
				</div>
				
			</el-form>
			<div :style="{textAlign:'right'}">
				
			</div>
			
			<el-button size='mini' type="primary" plain @click='TemporarySubmitForm'>暂存</el-button>
			<el-popconfirm
				confirm-button-text='保存'
				cancel-button-text='取消'
				title="保存后,出差报告以邮件的方式提交给领导，是否确认保存信息？"
				@confirm="SaveReviseForm"
				>
				<el-button size='mini' type='success' slot="reference" style="margin-left:10px;">保存</el-button>
			</el-popconfirm>
			<el-button @click="addDomain" style="margin-top:20px;margin-left:10px;" size='mini' type="primary" plain>新增行程</el-button>
		</div>
		
		<!-- 新建商场 -->
        <div class='MarketForm'>
            <!-- 新建商场弹框 -->
            <el-dialog title="商场信息" :visible.sync="MarketFormVisible" @close='resetMarketForm'>
                <el-form :model="Marketform" ref='Marketform' :rules='Marketrules' label-width="100px">
					<div class='Row'>
						<div class='row50'>
							<el-form-item prop='CHIC' label="品牌 " label-width='120px' class='Checkbox'>
								<el-checkbox v-model="Marketform.CHIC" :value='true'>CHIC</el-checkbox>                             
							</el-form-item>
							<el-form-item prop='JUST' class='Checkbox'> 
								<el-checkbox v-model="Marketform.JUST" :value='true'>JUST</el-checkbox>                              
							</el-form-item>
						</div>
						<div class='row50'>
							<el-form-item label="商场名称" prop='商场名称' label-width="120px">
								<el-input v-model="Marketform.商场名称"></el-input>
							</el-form-item>  
						</div>
					</div>
					<div class='Row'>
						<div class='row50'>
							<el-form-item label="所属物业" prop='所属物业ID' label-width="120px">
								<el-select v-model="Marketform.所属物业ID" :label-in-value="true" filterable placeholder="请选择" @change='ChangeTenement(Marketform.所属物业ID)'>
									<el-option v-for="item in 所属物业" :key="item.ID" :label='item.物业名称' :value="item.ID">{{item.物业名称}}</el-option>
								</el-select>
							</el-form-item> 
						</div>
						<div class='row50'>
							<el-form-item label="所属物业" prop='所属物业' label-width="120px" v-if='show'>
								<el-input v-model="Marketform.所属物业"></el-input>
							</el-form-item> 
						</div>
					</div>
					<div class='Row'>
						<div class='row50'>
							<el-form-item prop='省' label="所属省份" label-width="120px">
								<el-select placeholder="所属省份" v-model="Marketform.省" @change='getvalue(Marketform.省)' filterable>
									<el-option v-for='(item,index) in province' :value='item.省' :label='item.省' :key='index'></el-option>
								</el-select>
							</el-form-item> 
						</div>
						<div class='row50'>	
							<el-form-item prop='所属城市ID' label="所属市区" label-width="120px">
								<el-select placeholder="所属城市ID" v-model="Marketform.所属城市ID" filterable>
									<el-option v-for='(item,index) in town' :value='item.ID' :label='item.市' :key='index'></el-option>
								</el-select>
							</el-form-item> 
						</div>
					</div>
					<div class='Row'>
						<div class='row50'>
							<el-form-item label="商场地址" label-width="120px" prop='地址'>
								<el-input :autosize="{ minRows: 2, maxRows: 4}" v-model="Marketform.地址" type='textarea'></el-input>
							</el-form-item>
						</div>
						<div class='row50'>
							<el-form-item label="开业日期" label-width="120px" prop='开业日期'>
								<el-date-picker v-model="Marketform.开业日期" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" ></el-date-picker>
							</el-form-item>
						</div>
					</div>
					<div class='Row'>
						<div class='row50'>
							<el-form-item label="商场租金" label-width="120px" prop='租金'>
								<el-input v-model="Marketform.租金"></el-input>
							</el-form-item>
						</div>
						<div class='row50'>
							<el-form-item label="商场等级" prop='商场等级' label-width="120px">
								<el-select v-model="Marketform.商场等级" placeholder="商场等级">
									<el-option label="A+" value="A+"></el-option>
									<el-option label="A" value="A"></el-option>
									<el-option label="B" value="B"></el-option>
									<el-option label="C" value="C"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<div class='Row'>
						<div class='row50'>
							<el-form-item label="所处商圈" label-width="120px" prop='所处商圈'>
								<el-input v-model="Marketform.所处商圈"></el-input>
							</el-form-item>
						</div>
						<div class='row50'>	
							<el-form-item label="商场属性" prop='属性' label-width="120px">
								<el-radio-group v-model="Marketform.属性">
									<el-radio label='自营'>自营</el-radio>
									<el-radio label='合作'>合作</el-radio>
								</el-radio-group>
							</el-form-item>
						</div>
					</div>
					<div class='Row'>
						<div class='row50'>
							<el-form-item prop='有无国际区' label="所在区域" label-width='120px' class='Checkbox'>
								<el-checkbox v-model="Marketform.有无设计区" :value='true'>设计区</el-checkbox> 
							</el-form-item> 
							<el-form-item prop='有无国际区' class='Checkbox'>
								<el-checkbox v-model="Marketform.有无国际区" :value='true'>国际区</el-checkbox>
							</el-form-item> 
						</div>
					</div>
					<div class='Row'>
						<div class='row50'>
							<el-form-item label="调整日期" label-width="120px" prop='调整日期'>
								<el-select v-model="Marketform.调整日期" placeholder="请选择">
									<el-option v-for="(item,index) in month" :key="index" :label="item" :value="item">  </el-option>
								</el-select>
							</el-form-item> 
						</div>
						<div class='row50'>
							<el-form-item label="家居招商面积" label-width="120px" prop='家居招商面积'>
								<el-input v-model="Marketform.家居招商面积" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class='Row'>
						<div class='row50'>
							<el-form-item label="续约日期" label-width="120px" prop='续约日期'>
								<el-select v-model="Marketform.续约日期" placeholder="请选择">
									<el-option v-for="(item,index) in month" :key="index" :label="item" :value="item"></el-option>
								</el-select>
							</el-form-item> 
						</div>
						<div class='row50'>
							<el-form-item label="经营总面积" label-width="120px" prop='经营总面积'>
								<el-input v-model="Marketform.经营总面积" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class='Row'>
						<div class='row50'>
							<el-form-item label="更新日期" label-width="120px" prop='更新日期'>
								<el-date-picker v-model="Marketform.更新日期" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" readonly></el-date-picker>
							</el-form-item>
						</div>
						<div class='row50'></div>
					</div>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="resetMarketForm" size='small'>取 消</el-button>
                    <el-button type="primary" @click="NewCompany" :loading="MarketisDisable" size='small'>确 定</el-button>
                </div>
            </el-dialog>
        </div>

		<div class='ClientForm'>
            <!-- 新建客户弹框 -->
            <el-dialog title="客户信息" :visible.sync="ClientFormVisible" @close='resetClientForm'>
                <el-form :model="Clientform" label-width="120px" ref='Clientform' :rules='Clientrules'>
					<div class='Row'>
						<div class='row50'>
							<el-form-item prop='CHIC' label="品牌" class='Checkbox'>
								<el-checkbox v-model="Clientform.CHIC" :value='true'>CHIC</el-checkbox>                             
							</el-form-item>
							<el-form-item prop='JUST' label=" " class='Checkbox'> 
								<el-checkbox v-model="Clientform.JUST" :value='true'>JUST</el-checkbox>                              
							</el-form-item>
						</div>
						<div class='row50'>
							<el-form-item prop='企业名称' label="客户名称">
								<el-input v-model="Clientform.企业名称" placeholder="经销商或所在公司名字"></el-input>
							</el-form-item>
						</div>
					</div>

					<div class='Row'>
						<div class='row50'>
							<el-form-item prop='省' label="省份">
								<el-select v-model="Clientform.省" placeholder="请选择省份" @change='getvalue(Clientform.省)' filterable>
									<el-option v-for='(item,index) in province' :value='item.省' :label='item.省' :key='index'></el-option>
								</el-select>
							</el-form-item> 
						</div>
						<div class='row50'>
							<el-form-item prop='城市' label="城市">
								<el-select v-model="Clientform.城市" placeholder="请选择城市" @change='getshop(Clientform.城市)'>
									<el-option v-for='item in town' :value='item.ID' :label='item.市' :key='item.ID'></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<div class='Row'>
						<div class='row50'>
							<el-form-item prop='来源' label="来源">
								<el-select v-model="Clientform.来源" placeholder="--请选择--">
									<el-option label="物业推荐" value="物业推荐"></el-option>
									<el-option label="陌生拜访" value="陌生拜访"></el-option>
									<el-option label="既有经销商" value="既有经销商"></el-option>
									<el-option label="经销商介绍" value="经销商介绍"></el-option>
									<el-option label="展会" value="展会"></el-option>
									<el-option label="主动联系我方" value="主动联系我方"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div class='row50'>	
							<el-form-item prop='经营年限' label="经营年限">
								<el-select v-model="Clientform.经营年限" placeholder="--请选择--">
									<el-option label="3年以内" :value="`3年以内`"></el-option>
									<el-option label="3-8年" :value="`3-8年`"></el-option>
									<el-option label="8年以上" :value="`8年以上`"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<div class='Row'>
						<div class='row50'>
							<el-form-item label="地址" prop='地址'>
								<el-input v-model="Clientform.地址" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" class='Inputwidth'></el-input>
							</el-form-item>
						</div>
						<div class='row50'>
							<el-form-item prop='属性' label="经销商属性">
								<el-radio-group v-model="Clientform.属性">
									<el-radio label="待开拓">待开拓</el-radio>
									<el-radio label="现有经销商">现有经销商</el-radio>
								</el-radio-group>
							</el-form-item>
						</div>
					</div>
					<div class='Row'>
						<div class='row50' :style="{width:'100%'}">
							<el-form-item prop="特征" label="特征">
								<el-checkbox-group v-model="Clientform.特征">
									<el-checkbox label="家具经销商"></el-checkbox>
									<el-checkbox label="定制类"></el-checkbox>
									<el-checkbox label="建材类"></el-checkbox>
									<el-checkbox label="近三年新锐家具经销商"></el-checkbox>
									<el-checkbox label="近三年新锐家具&建材经销商"></el-checkbox>
									<el-checkbox label="其他产业转进"></el-checkbox>
									<el-checkbox label="设计师"></el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</div>
					</div>
					<div class='Row'>
						<div class='row50' :style="{width:'100%'}">
							<el-form-item prop="擅长优势" label="擅长优势">
								<el-checkbox-group v-model="Clientform.擅长优势">
									<el-checkbox label="零售">零售</el-checkbox>
									<el-checkbox label="渠道">渠道</el-checkbox>
									<el-checkbox label="楼盘开发">楼盘开发</el-checkbox>
									<el-checkbox label="不明确">不明确</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</div>
					</div>
					<div class='Row'>
						<div class='row50'>
							<el-form-item prop='匹配度' label="匹配度">
								<el-select v-model="Clientform.匹配度" placeholder="--请选择--">
									<el-option label="高" value="高"></el-option>
									<el-option label="中" value="中"></el-option>
									<el-option label="低" value="低"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<div class='Row'>
						<div class='row50'>
							<el-form-item label="备注" prop="备注">
								<el-input v-model="Clientform.备注" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" class='Inputwidth'></el-input>
							</el-form-item>
						</div>
					</div>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="resetClientForm" size='small'>取 消</el-button>
                    <el-button type="primary" @click="NewClient" :loading="ClientisDisable" size='small'>确 定</el-button>
                </div>
            </el-dialog>
        </div>

		<!-- 新建联系人列表 -->
        <div class='clientperson'>
            <!-- 新建联系人弹框 -->
            <el-dialog title="联系人信息" :visible.sync="dialogFormVisible" @close='resetForm'>
                <el-form :model="userform" ref='userform' :rules='rules'>
                        <!-- 姓名 -->
                    <el-form-item label="姓名" :label-width="formLabelWidth"  prop='联系人'>
                    <el-input v-model="userform.联系人" autocomplete="off"></el-input>
                    </el-form-item>
                    <!-- 性别 -->
                    <el-form-item label="性别" :label-width="formLabelWidth"  prop='性别'>
                    <el-select v-model="userform.性别" placeholder="请选择性别">
                        <el-option label="男" :value="true"></el-option>
                        <el-option label="女" :value="false"></el-option>
                    </el-select>
                    </el-form-item>
                    <!-- 职务 -->
                    <el-form-item label="职务" :label-width="formLabelWidth"  prop='职务'>
                    <el-input v-model="userform.职务" autocomplete="off"></el-input>
                    </el-form-item>
                    <!-- 联系方式 -->
                    <el-form-item label="联系方式" :label-width="formLabelWidth"  prop='联系方式'>
                    <el-input v-model="userform.联系方式" autocomplete="off"></el-input>
                    </el-form-item>
                    <!-- 喜好 -->
                    <el-form-item label="喜好" :label-width="formLabelWidth">
                    <el-input v-model="userform.喜好" autocomplete="off"></el-input>
                    </el-form-item>
                    <!-- 备注 -->
                    <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="userform.备注" autocomplete="off" type='text'></el-input>
                    </el-form-item>
                </el-form>
                <!-- 按钮 -->
                <div slot="footer" class="dialog-footer">
                    <el-button @click="resetForm" size='small'>取 消</el-button>
                    <el-button type="primary" @click="Newperson()" :loading="PersonisDisable" size='small'>确 定</el-button>
                </div>
            </el-dialog>
        </div>
	</div>
</template>

<script>
	import { EvectionReportInfo , Getfollowtheme , AboutClient , CompetitiveMall, ReviseEvectionReport , DeleteEvectionJourney, personlist,
			clientpersonlist  ,provincelist ,townlist, Newcitysubmit, shoppingMall ,Addclient, addclientperson , addperson, Belongcity,DeletePic} from '@/api/api.js'
	import { compressAccurately } from 'image-conversion' //按需引入
	import { uploadImgToBase64 } from '@/api/utils'; // 导入本地图片转base64的方法
	export default {
		data() {
			var validPhone=(rule,value,callback)=>{
                var isvalidPhone = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/
                if (!value){
                    callback(new Error('请输入电话号码'))
                }else if (isvalidPhone.test(value)){
                    callback()
                }else {
                    callback(new Error('请输入正确的11位手机号码'))
                }
            }
			return { 
				pickerOptions:{
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
				pickerDateTime:{						// 预计下次跟进日期
					disabledDate(time) {
						// return time.getTime() <= Date.now();
						return Date.now() > time.getTime();
					},
				},
				UserID:"",
				RevisereportForm:{},
				ReviseJourneyForm:{
					domains:[{拜访ID: '',联系人ID:'',Linkoptions:[],拜访日期:'',拜访方式:'',拜访类型:'',主题:[],跟进内容:'',近况:'',协助需求:'',难点:'',机会点:'',对策计划:'',预计下次跟进时间:'',预计签约时间:'',图片:[],图片地址:'',options:[],key:Date.now()}]
				},
				rules:{
					联系人: [
						{ required: true, message: ' ', trigger: 'blur' },
					],
					性别: [
						{ required: true, message: ' ', trigger: 'blur' },
					],
					职务: [
						{ required: true, message: ' ', trigger: 'blur' },
					],
					联系方式: [
						{ required: true,validator: validPhone, trigger: 'blur' },
					],
				},
				loading:false,
				theme:[],
				拜访类型:'',
				options:[],
				SubFormLoading:false,
				FormLoading:false,
				userform:{客户ID:'',商场ID:'',联系人: '',性别: '',职务:'',喜好:'无',备注:'无',联系方式:'',录入人:'',更新人ID:'',},
				formLabelWidth:'80px',
				dialogFormVisible:false,
				LinkMantype:'',
				LinkManIndex:'',
				MarketFormVisible:false,
				Marketform:{当前跟进人ID:'',JUST:'',CHIC:'',所属城市ID:'',所属物业ID:'',所属物业:'',省:'',商场名称:'',商场等级:'',开业日期:'',属性:'',有无国际区:'',有无设计区:'',地址:'',所处商圈:'',续约日期:'',调整日期:'',经营总面积:'',家居招商面积:'',租金:'',录入人:'',更新日期:new Date(),},
				所属物业:[],
				show:false,
				town:[],
				province:[],
				month:['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
				Marketrules:{
					商场名称: [
                        { required: true, message: ' ', trigger: 'blur' },
                    ],
                    商场等级: [
						{ required: true, message: ' ', trigger: 'change' },
					],
                     所属物业ID: [
						{ required: true, message: ' ', trigger: 'blur' },
					],
                    所属城市ID: [
                        { required: true, message: ' ', trigger: 'change' },
                    ],
                    省: [
                        { required: true, message: ' ', trigger: 'change' },
                    ],
                    属性:[
                         { required: true, message: '请选择商场属性！！', trigger: 'change' },
                    ]
				},
				isDisable:false,
				ClientisDisable:false,
				PersonisDisable:false,
				MarketisDisable:false,
				Clientform:{ID:'',城市:'',省:'',地址:'',企业名称:'',JUST:'',CHIC:'',属性:'',经营年限:'',来源:'',特征:[],擅长优势:[],匹配度:'',跟进状态:'新纪录',录入人:'',备注:'',当前跟进人ID: "",},
				ClientFormVisible:false,
				Clientrules:{
					省: [
                        { required: true, message: ' ', trigger: 'change' },
                    ],
                    城市: [
                        { required: true, message: ' ', trigger: 'change' },
                    ],
                    企业名称: [
                        { required: true, message: ' ', trigger: 'blur' },
                    ],
                    经营年限: [
                        { required: true, message: ' ', trigger: 'change' },
                    ],
                    匹配度: [
						{ required: true, message: '请选择商场匹配度！！', trigger: 'change' },
					],
                    特征: [
                            { required: true, message: '******', trigger: 'change' },
                        ],
                    来源: [
                        { required: true, message: ' ', trigger: 'change' },
                    ],
                    属性: [
                        { required: true, message: '请选择商场属性！！', trigger: 'change' },
                    ],
					擅长优势: [{ required: true, message: '******', trigger: 'change' }],
				},
				market:[],
				dialogImageUrl:'',
				dialogVisible:false,
				imgList:[],
				ImgUrl:[],
				// IP : 'http://localhost:17191',
				IP : 'http://chicst-mmwebapi.chiccasa.com.cn'
			}
		},
		methods: {
			addDomain() {
				this.ReviseJourneyForm.domains.push(
					{拜访ID: '',Linkoptions:[],联系人ID:'',拜访日期:'',拜访方式:'',拜访类型:'',主题:[],跟进内容:'',近况:'',协助需求:'',难点:'',机会点:'',对策计划:'',预计下次跟进时间:'',预计签约时间:'',options:[],图片:[],ImgUrl:[],图片地址:'',key:Date.now()}
				);
			},
			GetList(){
				this.FormLoading = true
				EvectionReportInfo(this.ID)
				.then(result=>{
					if(result.StatusCode == 200){
						this.RevisereportForm = result.Data.monad
						this.ReviseJourneyForm.domains = result.Data.detail
						this.ReviseJourneyForm.domains.forEach((v,index)=>{
							v.key = Date.now() + index
							v.主题 = v.主题.split(';')
							if(v.拜访类型 == '经销商'){
								AboutClient(v.姓名,this.UserID) 
								.then(result=>{
									if(result){
										this.$set(this.ReviseJourneyForm.domains[index],"options", result.Data)
										this.loading = false
									}
								})
								clientpersonlist(v.拜访ID)
								.then(result=>{
									this.$set(this.ReviseJourneyForm.domains[index],"Linkoptions", result.Data)
								})
							}else if(v.拜访类型 == '物业'){
								CompetitiveMall(v.姓名) 
								.then(result=>{
									if(result){
										result.Data.forEach(val=>{
											val.企业名称 = val.商场名称
											val.意向品牌 = ''
										})
										this.$set(this.ReviseJourneyForm.domains[index],"options", result.Data)
									}
								})
								personlist(v.拜访ID)
								.then(result=>{
									this.$set(this.ReviseJourneyForm.domains[index],"Linkoptions", result.Data)
								})
							}
							Getfollowtheme(v.拜访类型)
							.then(result=>{
								this.$set(this.ReviseJourneyForm.domains[index],"theme", result.Data)
							})						
							if(this.ReviseJourneyForm.domains[index].图片地址){
								this.$set(this.ReviseJourneyForm.domains[index],'图片',[])
								this.$set(this.ReviseJourneyForm.domains[index],'ImgUrl',[])
								let string = ''
								string = JSON.parse(JSON.stringify(this.ReviseJourneyForm.domains[index].图片地址.substr(0,this.ReviseJourneyForm.domains[index].图片地址.length)))
								let imgList = string.split('*D:/web/ChicST-MMWebApi')
								imgList.splice(0,1)
								imgList.map(val=>{
									this.ReviseJourneyForm.domains[index].图片.push({url:this.IP + val})
								})
							}
							this.ReviseJourneyForm.domains[index].图片地址 = ''
						})
					}
					this.FormLoading = false
				}).catch(err=>{
					this.$message({
						// 添加成功
						type: "error",
						message: '出差报告行程获取失败，请重新刷新获取,' + err,
						duration: 1500, 
					});
					this.FormLoading = false
				})
			},
			remoteMethod(query,index,object,domain){                                // 搜索选择拜访用户
				const _this = this
				let val = []
				// _this.$set(_this.ReviseJourneyForm.domains[index], "options", [])
				this.ReviseJourneyForm.domains[index].options = []
				if(query !== ''){
					this.loading = true;
					if(object == '经销商'){
						AboutClient(query,_this.UserID) 
						.then(result=>{
							if(result){
								_this.ReviseJourneyForm.domains[index].options =  result.Data
							}else{
								_this.ReviseJourneyForm.domains[index].options = []
							}
							_this.loading = false
						})
					}else if(object == '物业'){
						CompetitiveMall(query) 
						.then(result=>{
							if(result){
								result.Data.forEach(val=>{
									val.企业名称 = val.商场名称
									val.意向品牌 = ''
								})
								_this.ReviseJourneyForm.domains[index].options =  result.Data
								_this.loading = false
								// _this.$set(_this.ReviseJourneyForm.domains[index], "options", result.Data)
							}else{
								_this.ReviseJourneyForm.domains[index].options = []
								_this.loading = false
							}
						})
					}
				}else{
					_this.$set(_this.ReviseJourneyForm.domains[index], "options", [])
				}
			},
			ChangeObject(index,val){
				this.ReviseJourneyForm.domains[index].拜访ID = ''
				this.ReviseJourneyForm.domains[index].options = []
				this.ReviseJourneyForm.domains[index].联系人ID = ''
				this.ReviseJourneyForm.domains[index].Linkoptions = []
				this.ReviseJourneyForm.domains[index].主题 = []
				console.log(val)
				if(val == '物业'){
					console.log(123456)
					this.ReviseJourneyForm.domains[index].意向商场 = ''
					this.ReviseJourneyForm.domains[index].意向位置 = ''
					this.ReviseJourneyForm.domains[index].投资预算 = ''
					this.ReviseJourneyForm.domains[index].预算面积 = ''
					this.ReviseJourneyForm.domains[index].意向度 = ''
					console.log(this.ReviseJourneyForm.domains[index].意向商场)
				}
				
				Getfollowtheme(val)
				.then(result=>{
					if(result){
						this.ReviseJourneyForm.domains[index].theme = result.Data
					}
				})		
			},
			removeDomain(item) {						//  删除行程单
				const _this = this
				if(item.ID){
					DeleteEvectionJourney(item.ID)
					.then(result=>{
						if(result.StatusCode == 200){
							_this.$message({
								// 添加成功
								type: "success",
								message: '出差报告行程删除成功！！',
								duration: 1500, 
							});
							_this.GetList()
						}
					})
				}else{
					var index = _this.ReviseJourneyForm.domains.indexOf(item)
					if (index !== -1) {
						_this.ReviseJourneyForm.domains.splice(index, 1)
					}
				}
			},
			getvalue(val){										// 获取市区
				this.Marketform.所属城市ID=''
				this.Clientform.城市=''
				this.town = []
				// 获取市列表
				townlist(val)
				.then(result =>{
					this.town = result.Data
				})
			},
			getshop(ID){
				shoppingMall(ID)  
				.then(result=>{
					this.market = result.Data
				})
			},
			AddCompany(index,type){									// 新增企业信息弹框
				if(type){
					// 获取省份
					provincelist()
					.then(result =>{
						this.province = result.Data 
					}).catch(err=>{
						this.$message({
                            message: '获取信息失败,' + err,
                            type: "error",
                            duration: 1500,
                        });
					})
					if(type == '经销商'){
						this.ClientFormVisible = true
						
					}else if(type == '物业'){
						this.LinkManIndex = index
						this.LinkMantype = type
						this.MarketFormVisible = true
					}
				}else{
					this.$message({
						type: "error",
						message: '请先选择客户类型！！',
						duration: 1300, 
					});
				}	
			},
			resetMarketForm(){
				this.MarketFormVisible = false
				this.MarketisDisable = false 
                this.$refs.Marketform.resetFields()
			},
			NewCompany(){												// 新增商场信息
				// console.log(this.Marketform)
				const _this = this
				_this.MarketisDisable = true 
				if(_this.Marketform.JUST == false && _this.Marketform.CHIC == false){
					this.$message({
						// 提交失败
						type: "error",
						message: '请选择品牌信息',
						duration: 1500,
					});
					_this.MarketisDisable = false 
				}else{
					_this.$refs.Marketform.validate((valid) => {
						if(valid){
							Newcitysubmit(_this.Marketform)
							.then( result =>{
								if (result.StatusCode == 200) {
									this.$message({
										// 提交成功
										type: "success",
										message: '提交成功',
										duration: 1500,
									});
									// this.MarketFormVisible = false
									_this.resetMarketForm()
									_this.MarketisDisable = false
								} else {
									this.$message({
										// 提交失败
										type: "error",
										message: '提交失败',
										duration: 1500,
									});
									_this.MarketisDisable = false // 禁用按钮 防止重复提交
								}
							}).catch(err=>{
								this.$message({
									// 添加失败
									type: "error",
									message: '信息添加失败，'+ err,
									duration: 1300, 
								});
								_this.MarketisDisable = false // 禁用按钮 防止重复提交
							})
						}else{
							this.$message({
								message: "请填写所有必填项!",
								type: "error",
								duration: 1300,
							});
							_this.MarketisDisable = false 
						}
					})
				}
			},
			resetClientForm(){
				this.ClientFormVisible = false
				this.ClientisDisable = false
                this.$refs.Clientform.resetFields()
			},
			NewClient(){												// 新增客户信息
				const _this = this
				_this.ClientisDisable = true
				
					if(_this.Clientform.JUST == false && _this.Clientform.CHIC == false){
						this.$message({
							// 提交失败
							type: "error",
							message: '请选择品牌信息',
							duration: 1500,
						});
						_this.ClientisDisable = false 
					}else{
						_this.$refs.Clientform.validate(valid => {
							if (valid) {
								_this.Clientform.特征 = _this.Clientform.特征.join(',')
								_this.Clientform.擅长优势 = _this.Clientform.擅长优势.join(',')
								Addclient(_this.Clientform)
								.then(result =>{
									if (result.StatusCode == 200) {
										this.$message({
											// 添加成功
											type: "success",
											message: '添加成功',
											duration: 1500,
										});
										// this.ClientFormVisible = false
										_this.resetClientForm()
										_this.ClientisDisable = false
									} else {
										_this.Clientform.特征 = _this.Clientform.特征.split(',')
										_this.Clientform.擅长优势 = _this.Clientform.擅长优势.split(',')
										this.$message({
											// 删除失败
											type: "error",
											message: '提交失败',
											duration: 1500,
										});
										_this.ClientisDisable=false
									}
								}).catch(err=>{
									this.$message({
										// 删除失败
										type: "error",
										message: '信息提交失败，' + err,
										duration: 1500,
									});
									_this.ClientisDisable=false
								})
							}else{
								_this.$message({
									message: '请完整填写必填项，提交失败',
									type: "error",
									duration: 1500,
								});
								_this.ClientisDisable=false
							}
						})
					}
			},
			AddLinkMan(ID,index,type){									//新增联系人弹窗
				if(ID){
					this.dialogFormVisible = true
					this.userform.客户ID = ID
					this.userform.商场ID = ID
					this.LinkManIndex = index
					this.LinkMantype = type
				}else{
					this.$message({
						type: "error",
						message: '请先选择拜访的客户名称！！',
						duration: 1300, 
					});
				}
			},
			resetForm(){
				this.dialogFormVisible = false
				this.PersonisDisable = false 
                this.$refs.userform.resetFields()
			},
			Newperson(){												//新增联系人
                  // 保存this
                const _this = this
				let resultData = []
                _this.PersonisDisable = true  // 按钮的禁用  
                _this.$refs.userform.validate((valid) => {
                    if(valid){
                        _this.userform.录入人 = sessionStorage.getItem('name')   // 获取录入人姓名
                        _this.userform.更新人ID = sessionStorage.getItem('ID')   // 获取录入人姓名
                        // 接口
						if(this.LinkMantype == '经销商'){
							addclientperson(_this.userform)
							.then( result =>{
								if(result.StatusCode == 200){
									this.$message({
										// 添加成功
										type: "success",
										message: '添加成功',
										duration: 1300, 
										onClose(){
											_this.resetForm()
											_this.PersonisDisable = false      // 防止重复提交，禁用按钮
											}
										});
									this.remoteLinkman(this.userform.客户ID,this.LinkManIndex,this.LinkMantype)
								}else{
									this.$message({
										// 添加失败
										type: "error",
										message: '添加失败',
										duration: 1300,
									});
									_this.PersonisDisable = false 	// 按钮的禁用
								}
							})
						}else if(this.LinkMantype == '物业'){
							addperson(_this.userform) //  调用接口
							.then( result =>{
								if (result.StatusCode == 200) {
									this.$message({
										// 添加成功
										type: "success",
										message: '添加成功',
										duration: 1300, 
										onClose(){
											_this.resetForm()
											_this.PersonisDisable = false      // 防止重复提交，禁用按钮
											// _this.reload()
											}
										});
									this.remoteLinkman(this.userform.客户ID,this.LinkManIndex,this.LinkMantype)
								} else {
									this.$message({
										// 添加失败
										type: "error",
										message: '添加失败',
										duration: 1300, 
									});
									_this.PersonisDisable = false  // 按钮的禁用
								}
							}).catch(err=>{
								this.$message({
									// 添加失败
									type: "error",
									message: '信息添加失败，'+ err,
									duration: 1300, 
								});
								_this.PersonisDisable = false  // 按钮的禁用
							})
						}
                    }else{
                        this.$message({
							message: "添加失败!",
							type: "error",
							duration: 1300,
						});
						_this.PersonisDisable = false  // 按钮的禁用
						return false;
                    }
                })
            },
			remoteLinkman(val,index,type){								//查询联系人
				const _this = this
				_this.ReviseJourneyForm.domains[index].Linkoptions = []
				_this.ReviseJourneyForm.domains[index].联系人ID = ''
				if(type == '经销商'){
					clientpersonlist(val)
					.then(result=>{
						_this.ReviseJourneyForm.domains[index].Linkoptions = result.Data
					})
				}else if(type == '物业'){
					personlist(val)
					.then(result=>{
						_this.ReviseJourneyForm.domains[index].Linkoptions = result.Data
					})
				}
			},
			async imgBroadcastChange(file,fileList,index){
				const _this = this
				let fileraw = []
				return new Promise(async (resolve, reject) => {
					const isJPG = file.raw.type === 'image/jpeg';
					const isPng = file.raw.type === 'image/png';
				// 每个限制返回错误信息   都需要用到reject()
					if (!isJPG && !isPng) {
						this.$message.error('上传图片只能是 JPG/PNG 格式!')
						fileList.forEach((v,i)=>{
							if(file.name == v.name){
								fileList.splice(i,1)
							}
						})
						return reject(false);  //注意这里需要用reject来返回错误的信息,防止图片自动上传
					}
					let compress = 1024  // 假设图片限制不能大于2M
					let sizeOver = file.size / 1024 > compress; //文件大小 是否大于指定大小
					if (sizeOver && compress) { //大于2M进行压缩
					const res = await compressAccurately(file.raw, {
						size: compress, //需要压缩的大小
						accuracy: 0.9, //精度 0.8-0.99之间 默认值0.95
						type: 'image/jpeg',
						width: 105,
						height: 105,
						orientation: 2,
						scale: 0.5,
					});
					file.raw = res; //把得到的新的图片文件赋值给原文件,然后进行上传
				}
				const imgBroadcastListBase64 = []
				this.dialogFormLoading = true
				// 并发 转码轮播图片list => base64
					const filePromises = fileList.map(async value => {
						if (value.raw) { // 如果是本地文件
							const response = await uploadImgToBase64(value.raw)
							return {Base64:response.result.replace(/.*;base64,/, ''),uid:value.uid}
							// console.log('value.raw',value.raw)
						}else{
							return {Base64:'',uid:value.uid}
						}

						// 按次序输出 base64图片
						// _this.ItineraryForm.图片 = diaLogForm
					})
					for (const textPromise of filePromises) {
						// console.log('filePromises',textPromise)
						imgBroadcastListBase64.push(await textPromise)
					}
					// let diaLogForm = imgBroadcastListBase64.join('*')
					// console.log(diaLogForm)
					// _this.ReviseJourneyForm.domains[index].图片地址 = diaLogForm
				// 	console.log('图片地址',_this.ReviseJourneyForm.domains[index])

				this.ReviseJourneyForm.domains[index].ImgUrl = imgBroadcastListBase64
				resolve(true) // 通过resolve将Promise函数返回成功回调,进行后面操作
			})
				
			},
			// 图片删除
			handleRemove(file, fileList,ID,index) {
				const _this = this
				if(file.raw){
					this.ReviseJourneyForm.domains[index].ImgUrl.forEach((val,i)=>{
						if(file.uid == val.uid){
							// console.log(111)
							this.ReviseJourneyForm.domains[index].ImgUrl.splice(i,1)
						}
					})
				}else{
					let Url = file.url.split('cn')
					let deleteUrl = 'D:/web/ChicST-MMWebApi' + Url[1]
					DeletePic(deleteUrl,ID)
					.then(result=>{
						if(result.StatusCode == 200){
							_this.$message({
								// 添加成功
								type: "success",
								message: '图片删除成功！！！',
								duration: 1500, 
							});
						}else{
							fileList.push(file)
						}
					})
				}
				// _this.ReviseJourneyForm.domains[index].图片 = fileList
			},
			handlePictureCardPreview(file) {
				// console.log(file.url)
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			TemporarySubmitForm(){
				const _this = this
				this.RevisereportForm.存储状态 ='false'
				if((this.RevisereportForm.开始时间 == '')||(this.RevisereportForm.开始时间 == null)){
					_this.$message({
						// 添加成功
						type: "error",
						message: '请填写您出差的开始时间！！',
						duration: 1500, 
					});
					_this.SubFormLoading = false
					return false;
				}else if(this.ReviseJourneyForm.domains.length == 0){
					this.$message({
						// 添加成功
						type: "error",
						message: '请添加您的出差日程！！！！',
						duration: 1500, 
					});
					_this.SubFormLoading = false
					return false;
				}else{
					this.SubmitReviseForm()
				}
			},
			SaveReviseForm(){
				this.RevisereportForm.存储状态 ='true'
				if(this.RevisereportForm.开始时间 == ''||this.RevisereportForm.开始时间 == null){
					this.$message({
						// 添加成功
						type: "error",
						message: '请填写您出差的开始时间！！',
						duration: 1500, 
					});
					return false;
				}else if(this.ReviseJourneyForm.domains.length == 0){
					this.$message({
						// 添加成功
						type: "error",
						message: '请添加您的出差日程！！！！',
						duration: 1500, 
					});
					return false;
				}else{
					this.SubmitReviseForm()
				}
			},
			SubmitReviseForm(){
				const _this = this
				_this.SubFormLoading = true
				
				this.$refs.ReviseJourneyForm.validate((valid) => {
					if(valid){
						let arr = []
						_this.ReviseJourneyForm.domains.forEach((value,index)=>{
							if(value.ImgUrl){
								value.ImgUrl.forEach(val=>{
									arr.push(val.Base64)
									value.图片地址 = arr.join('*')
								})
							}
							value.主题 = value.主题.join(';')
						})
						let Form = {
							monad : _this.RevisereportForm,
							detail:_this.ReviseJourneyForm.domains,
						}
						ReviseEvectionReport(Form)
						.then(result=>{
							if(result.StatusCode == 200){
								_this.$message({
									// 添加成功
									type: "success",
									message: '出差报告添加成功！！',
									duration: 1500, 
								});
								// 报告列表页
								_this.$router.push({path:'/home/EvectionreportList'})
							}
							_this.SubFormLoading = false
						}).catch(err=>{
							_this.$message({
								// 添加成功
								type: "error",
								message: '出差报告修改失败,请重新添加,'+ err,
								duration: 1500, 
							});
							_this.ReviseJourneyForm.domains.forEach((value,index)=>{
								value.主题 = value.主题.split(';')
							})
							_this.SubFormLoading = false
						})
					}else{
						_this.$message({
							// 添加成功
							type: "error",
							message: '请填写所有必填项！！',
							duration: 1500, 
						});
						_this.SubFormLoading = false
						return false;
					}
				})
			},
		},
		mounted() {
			const _this = this
			this.UserID = sessionStorage.getItem('ID')
			this.ID = this.$route.query.id
			_this.GetList()

			// 获取省份
            provincelist()
            .then(result =>{
                this.province = result.Data 
            })

			Belongcity()
            .then(result=>{
                this.所属物业 = result.Data
            })
			this.Clientform.录入人 = sessionStorage.getItem('name')
			this.Clientform.当前跟进人ID = sessionStorage.getItem('ID')
			this.Marketform.录入人 = sessionStorage.getItem('ID')
			this.Marketform.当前跟进人ID = sessionStorage.getItem('ID')
		}
	}
</script>

<style scoped lang="less">

#ReviseEvectionreport{
	.RevisereportForm{
		margin:10px;
	}
	.MarketForm,.ClientForm{
		/deep/.el-dialog{
			width:70%;
		}
		.Row{
			.row50{
				width: 45%;
				float: left;
				.el-form-item{
					margin-bottom:10px;
				}
			}
			.row50:nth-child(2n){
				float: right;
			}
		}
		.Row:after{
			content: ".";
			display: block;
			height: 0;
			clear: both;
			visibility: hidden;
		}
		.Checkbox{
			display:inline-block;
			padding-right:15px;
		}
	}
}
</style>
